import ApiConfig from "../../Utils/Configs/apiConfig";

export const WhiteListEmail = async (data: { email: string }) => {
  try {
    const response = await ApiConfig.getInstance().post(
      "/Account/add-whitelist",
      data
    );
  } catch (error: any) {}
};
